import React, { Component } from 'react';
import {
  Dimensions,
  FlatList,
  PixelRatio,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import Icon from '../common/Icon';

export const filterItemList = [
  {
    key: 'today',
    title: 'Hôm nay',
  },
  {
    key: 'yesterday',
    title: 'Hôm qua',
  },
  {
    key: 'this-week',
    title: 'Tuần này',
  },
  {
    key: 'this-month',
    title: 'Tháng này',
  },
  {
    key: 'all',
    title: 'Tất cả',
  },
  {
    key: '@cod',
    title: 'COD',
  },
  {
    key: '@confirmed',
    title: 'Đã chốt',
  },
  {
    key: '@placed',
    title: 'Đặt hàng',
  },
  {
    key: '@shipping',
    title: 'Đang vận chuyển',
  },
];

class FilterList extends Component {

  constructor (props) {
    super(props);

    const {filter} = this.props;
    this.state = {
      filter: filter,
    };
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.filter !== nextProps.filter) {
      this.setState({
        filter: nextProps.filter,
      });
    }
  }

  _renderItem = ({item, index}) => {
    const selected = item == this.state.filter;
    return (
      <FilterItem
        item={item}
        selected={selected}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (item) => {
    const {onSelectFilter} = this.props;
    if (onSelectFilter) {
      onSelectFilter(item);
    }
  };

  _close () {
    const {onClose} = this.props;
    if (onClose) {
      onClose();
    }
  }

  render () {
    const {dataProvider} = this.state;
    return (
      <View
        style={styles.container}>
        <View
          style={styles.content}>
          <View
            style={styles.title}>
            <Text
              style={styles.titleText}>
              Bộ lọc
            </Text>
            <TouchableOpacity
              activeOpacity={0.75}
              style={styles.close}
              onPress={() => this._close()}>
              <Text
                style={styles.closeText}>
                Đóng
              </Text>
            </TouchableOpacity>
          </View>
          <FlatList
            extraData={this.state}
            data={filterItemList}
            renderItem={this._renderItem}
            style={styles.list}/>
        </View>
      </View>
    );
  }
}

class FilterItem extends React.PureComponent {

  _handleClick = () => {
    const {item, onClick} = this.props;
    if (onClick) {
      onClick(item);
    }
  };

  render () {
    const {item, selected} = this.props;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        style={styles.item}
        onPress={this._handleClick}>
        <Text
          style={[
            styles.itemText, {
              color: selected ? '#6b7adc' : '#000000',
            }]}>
          {item.title}
        </Text>
        {selected && <Icon
          type='FontAwesome'
          name='check'
          color='#6b7adc'
          size={16}
          style={styles.itemIcon}/>}
        <View
          style={styles.itemDivider}/>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000bf',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: Dimensions.get('window').width * 3 / 4,
    height: Dimensions.get('window').height * 2 / 3,
    backgroundColor: '#ffffff',
  },
  title: {
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1c9938',
  },
  titleText: {
    color: '#ffffff',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  close: {
    position: 'absolute',
    top: 0, right: 10, bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },
  closeText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  list: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  item: {
    height: 44,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemText: {
    flex: 1,
    marginLeft: 8,
    marginRight: 8,
    fontSize: 15,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  itemIcon: {
    marginRight: 8,
  },
  itemDivider: {
    position: 'absolute',
    left: 0, bottom: 0, right: 0,
    height: 1 / PixelRatio.get(),
    backgroundColor: '#e0e0e0',
  },
});

export default FilterList;



// WEBPACK FOOTER //
// ./src/order/FilterList.js